<template>
  <div class="list">
    <div
      class="list-detail-container"
      v-for="(item, index) in list"
      :key="index"
    >
      <div class="list-item">
        <div class="img">
          <a
            v-if="item.addr_url == ''"
            href="javascript:;"
            :title="item.addr_url"
          >
            <img :src="`${filePreview}${item.cover}`" alt="" />
          </a>
          <a
            v-else
            :href="item.addr_url"
            target="_blank"
            :title="item.addr_url"
          >
            <img :src="`${filePreview}${item.cover}`" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bread from "./Bread.vue";
export default {
  components: {
    Bread,
  },
  name: "Project",
  data() {
    return {
      filePreview: `${window._CONFIG["filePreview"]}?fileId=`,
      list: [],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      let url = `${window._CONFIG["domianURL"]}xmu/index/getData/3647ad55f0a74958a7572bea895bb66f`;
      // let token = JSON.parse(localStorage.getItem("pro__Access-Token")).value;
       let params = {
        pageNo: 1,
        pageSize: 999,
        is_publish: 1,
        column: "id",
        order: "desc",
        superQueryMatchType: "and",
      };
      this.$axios({
        method: "get",
        url: url,
        params: params,
        headers: {},
      }).then((res) => {
        let data = res.data.result.records;
        console.log(`project`, data);
        data.forEach((item) => {
          if (item.is_publish == 1) {
            this.list.push({
              cover: item.cover,
              addr_url: item.addr_url,
            });
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
header {
  background-color: rgb(0 0 0 / 10%);
}

.list {
  margin: 0 190px 15px 190px;
  padding-bottom: 25px;
  position: relative;
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr 1fr;
  row-gap: 34px;
  -moz-column-gap: 38px;
  column-gap: 20px;
}

.list-item {
  box-shadow: 0px 0px 13px 0px rgb(0 24 47 / 14%);
  display: flex;
  justify-content: center;
  align-items: center;
  .img {
    width: 170px;
  }
  .name {
    font-size: 20px;
    color: #575a7b;
    font-family: "Poppins", sans-serif;
    border-color: #333333;
    border-style: solid;
    border-width: 0px;
    word-break: break-word;
    text-align: -webkit-center;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    height: 80px;
    width: 100%;
    object-fit: contain;
  }
}
.img {
  width: 220px;
  background-color: #ffffff;
}

/deep/.el-menu {
  background-color: unset;
}

/deep/.el-table thead {
  color: #fff;
  font-weight: 500;
  background-color: #032f6d;
}

/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #f1f7ff;
}
</style>
